import React, { Component } from "react";
import { QuestionTable } from "../QuestionTable";

export class QuestionTableAdapter extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <QuestionTable
          {...this.props}
          onCellChange={this.props.onCellChange}
          submitAnswer={this.props.submitAnswer}
          setShowHint={this.props.setShowHint}
          showNextHint={this.props.showNextHint}
          cellHeight={this.props.cellHeight}
        />
      </div>
    );
  }
}
